import axios, { AxiosRequestConfig } from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class CardServices {
  async getByAll(params: AnalyserOptions): Promise<any[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = {
          limit: 999,
          ...params,
        }
      }
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/card/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const cardServices = new CardServices()
